import { Doughnut } from 'react-chartjs-2'
import Chart from 'chart.js/auto';

function ranIn() {
    return Math.floor(
        Math.random() * 256
    )
}

function ranColor(){
    const r = ranIn()
    const g = ranIn()
    const b = ranIn()
    return `rgb(${r},${g}, ${b})`
}

function DoughnutChart() {
    const color = [ranColor(), ranColor(), ranColor(),ranColor(), ranColor()]
    return (
        <Doughnut
            data={{
                labels: [
                    "Africa",
                    "Asia",
                    "Europe",
                    "Latin America",
                    "North America"
                ],
                datasets: [
                    {
                        label: "Doanh thu",
                        backgroundColor: color,
                        data: [2478, 5267, 734, 784, 433]
                    }
                ]
            }}
        />
    );
}

export default DoughnutChart;